<template lang="html">
  <v-container fluid>
    <v-layout column wrap align-center justify-center>
      <br><br>
      <h2>Página Inicial</h2>
      <br>
      <div style="padding-top: 10px;"></div>
      <router-link to="/consulta-projetos" tag="button">
        <v-btn color="primary" large>Consulta</v-btn>
      </router-link>
      <br>
      <div style="padding-top: 10px;"></div>
      <router-link to="/ajuda" tag="button">
        <v-btn color="primary" large>Ajuda</v-btn>
      </router-link>

    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'

  export default {
    name: 'ajuda',
    methods: {
      cardClick: function () {
        console.log('Clicou')
      }
    },
    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>

<style lang="css">
  a,
  a:hover {
    text-decoration: none;
  }
  a:hover .v-icon {
    color: #1976D2;
    transition: 0s;
  }
  .efeito-hover .v-card {
    cursor: pointer;
    transition:
      box-shadow 0.1s,
      transform 0.1s;
  }
  .efeito-hover .v-card:hover {
    box-shadow: 0px 0px 10px 3px #1976D2 !important;
    transform: scale(1.05);
  }
</style>



// WEBPACK FOOTER //
// inicio.vue?12754048